import { ResponsiveMixin } from '@/modules/core/ui/mixins/ResponsiveMixin';

export const MobileTooltipPositioningMixin = {
  mixins: [ResponsiveMixin],
  methods: {
    adjustTooltipPositionForMobile(tooltipEl, triggerEl) {
      if (!tooltipEl || !this.isMobile) return;

      // Hide tooltip initially to prevent visual glitch
      tooltipEl.style.opacity = '0';
      tooltipEl.style.visibility = 'hidden';

      this.$nextTick(() => {
        setTimeout(() => {
          const viewportWidth = window.innerWidth;
          const padding = 16; // 1rem
          const leftOffset = 20; // Shift tooltip left
          const maxWidth = viewportWidth - padding * 2;

          // Set max-width to prevent overflow
          tooltipEl.style.maxWidth = `${maxWidth}px`;
          tooltipEl.style.boxSizing = 'border-box';
          void tooltipEl.offsetWidth; // Force reflow

          // Get tooltip and trigger dimensions
          const tooltipWidth = tooltipEl.getBoundingClientRect().width;
          const triggerRect = triggerEl?.getBoundingClientRect();

          // Calculate centered position below trigger with left offset
          const triggerCenter = triggerRect
            ? triggerRect.left + triggerRect.width / 2
            : viewportWidth / 2;
          let targetLeft = triggerCenter - tooltipWidth / 2 - leftOffset;

          // Constrain to viewport bounds
          targetLeft = Math.max(
            padding,
            Math.min(targetLeft, viewportWidth - tooltipWidth - padding)
          );

          // Apply position
          tooltipEl.style.left = `${targetLeft}px`;
          tooltipEl.style.right = 'auto';
          tooltipEl.style.transform = 'none';

          // Show tooltip after positioning is complete
          tooltipEl.style.opacity = '1';
          tooltipEl.style.visibility = 'visible';
        }, 50);
      });
    }
  }
};

